import { useQuery } from '@tanstack/react-query'

import { importFilterSurgeryFolderMetadata } from '~/store/di-entity.api'

import { MultiQueryOptions } from '../useMultiQuery'

export const USE_SURGERY_META_DATA_QUERYKEY_PREFIX = 'surgeryMetadata'

/**
 * Fetch surgery metadata that is associated with DIPS surgeries (both unscheduled and scheduled).
 * Supports folder IDs.
 *
 * @param folderIds - Array of DIPS folder IDs to filter the surgery metadata.
 * @param options - (Optional) Parameters for the query, such as skip and staleTime.
 */
export const useSurgeryMetadataQuery = (folderIds: string[], options?: MultiQueryOptions) => {
    const surgeryMetadataFolderIdsQuery = useQuery({
        queryFn: () => importFilterSurgeryFolderMetadata({ folder_id: folderIds }),
        queryKey: [USE_SURGERY_META_DATA_QUERYKEY_PREFIX, { folder_id: folderIds }],
        enabled: !options?.skip && folderIds.length > 0,
        // When `folderIds` (i.e. the `queryKey`) changes, `placeholderData` prevents treating this as new query
        // This is because the scheduled/unscheduled surgeries query should be the source of truth for the loading state
        placeholderData: prev => prev,
        staleTime: options?.staleTime,
        // No refetchInterval here as our entities are updated through web socket updates
    })

    return surgeryMetadataFolderIdsQuery
}
